import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FeedbackModule } from "@/components/quiz/FeedbackModule";
import { useEffect } from "react";

const Feedback = () => {
  useEffect(() => {
    document.title = "Share Feedback | We-Help.in";
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 container py-12 max-w-3xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
            Share Feedback
          </h1>
          <p className="text-muted-foreground">
            Your feedback helps improve free education and career guidance for students across India.
          </p>
        </div>
        <FeedbackModule sourcePage="/feedback" />
      </main>
      <Footer />
    </div>
  );
};

export default Feedback;